const API_URL = process.env.VUE_APP_URL

const getScreeningByPersonId = async (mode, user, personId) => {
  try {
    const response = await window.axios.get(API_URL + `/screenings/${mode}/${user}/${personId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

const defineUpdatePayload = (selectedFindings, evalResults, savedDiagnoses, doctorReferrals) => {
  const diagnosis = {
    ID: savedDiagnoses ? savedDiagnoses.ID : "",
    diagnosis: evalResults.diagnoseHtml, // We should use html instead o text because it's easier to split when we get the data back
    recommendation: evalResults.recommendHtml
  }
  const doctorReferralsList = []
  doctorReferrals.forEach((doctor) => {
    const referral = {
      ID: doctor.userId,
      doctorID: doctor.doctorId
    }
    doctorReferralsList.push(referral)
  })

  return {
    findings: Object.values(selectedFindings).flat(),
    diagnosis: diagnosis,
    referralDoctors: doctorReferralsList
  }
}

export default {
  getScreeningByPersonId,
  defineUpdatePayload
}
